import { Link } from "react-router-dom";
import { Clock, ArrowRight, CalendarDays } from "lucide-react";
import { TYPE_LABEL } from "./TaskRow";

/**
 * Bug 19/50 · Home · "Agenda di oggi".
 *
 * Riceve `items[]` = task con `scheduled_date == today` (eventi + azioni figlie
 * schedulate oggi). Ordinati per `scheduled_time ASC NULLS LAST`.
 *
 * Azioni senza data NON entrano qui (garantito dal parent che filtra prima
 * di passare items).
 */
export default function TodayAgenda({ items = [], areasById = {} }) {
  return (
    <section className="pxos-card p-5" data-testid="home-today-agenda">
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-display text-lg font-semibold inline-flex items-center gap-2">
          <CalendarDays size={16}/> Agenda di oggi
          <span className="text-[10px] uppercase tracking-widest opacity-60 px-1.5 py-0.5 rounded-full border"
                data-testid="home-today-agenda-count">
            {items.length}
          </span>
        </h2>
        <Link to="/agenda?view=day" className="text-xs inline-flex items-center gap-1 opacity-70 hover:opacity-100"
              data-testid="home-today-agenda-see-all">
          Vedi tutta l'agenda <ArrowRight size={12}/>
        </Link>
      </div>
      {items.length === 0 ? (
        <div className="text-sm opacity-70 py-3" data-testid="home-today-agenda-empty">
          Nessun appuntamento o azione programmata per oggi.
        </div>
      ) : (
        <ul className="divide-y" style={{ borderColor: "var(--pxos-border)" }}>
          {items.map((t) => {
            const area = t.area_id ? areasById[t.area_id] : null;
            const timeLabel = t.scheduled_time ? t.scheduled_time.slice(0, 5) : "—:—";
            const typeLabel = TYPE_LABEL[t.type] || t.type;
            return (
              <li key={t.id} className="flex items-center gap-3 py-2"
                  data-testid={`home-today-agenda-item-${t.id}`}>
                <span className="text-xs tabular-nums opacity-70 shrink-0 w-14 inline-flex items-center gap-1">
                  <Clock size={11}/> {timeLabel}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{t.title}</div>
                  <div className="text-[11px] opacity-70 mt-0.5 flex items-center gap-2 flex-wrap">
                    <span>{typeLabel}</span>
                    {area && (
                      <span className="inline-flex items-center gap-1">
                        · <span className="w-1.5 h-1.5 rounded-full" style={{ background: area.color || "#95BAEF" }}/>
                        {area.name}
                      </span>
                    )}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
